import UpdateOrientationExpensePopup from "../../../components/Recruiting/OrientationExpenses/UpdateOrientationExpensePopup";
import RecruitingDeleteButton from "../../../components/Recruiting/RecruitingDeleteButton/RecruitingDeleteButton";

export const orientationExpenseTableColumns = (orientationId?: string) => [
  {
    field: "driverName",
    headerName: "Driver",
    width: 180,
    valueGetter: (value: string, row: any) =>
      `${row.driverFirstName ?? ""} ${row.driverLastName ?? ""}`.trim(),
  },
  { field: "expenseType", headerName: "Expense Type", width: 160 },
  {
    field: "cost",
    headerName: "Cost",
    width: 140,
    valueFormatter: (value: number) =>
      value || value === 0 ? `$${Number(value).toFixed(2)}` : "",
  },
  { field: "paidBy", headerName: "Paid By", width: 140 },
  { field: "notes", headerName: "Notes", width: 220 },
  { field: "hotelDaysNeeded", headerName: "Hotel Days", width: 140 },
  {
    field: "update",
    headerName: "",
    width: 140,
    renderCell: (params: any) => (
      <UpdateOrientationExpensePopup expense={params.row} />
    ),
  },
  {
    field: "delete",
    headerName: "",
    width: 140,
    renderCell: (params: any) => (
      <RecruitingDeleteButton
        id={params.row.id}
        endpoint="recruiting/expense"
        entityLabel="expense"
        queryKey={["orientationExpenses", orientationId]}
      />
    ),
  },
];
